'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var generateShimmerCss = require('./generateShimmerCss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Photo = styled__default["default"].div.withConfig({
  componentId: "sc-vr9oku-0"
})(["height:165px;width:165px;", ""], generateShimmerCss["default"]({
  start: '-1584px',
  stop: '1584px',
  size: '1584px'
}));
const Title = styled__default["default"].div.withConfig({
  componentId: "sc-vr9oku-1"
})(["height:24px;max-width:180px;width:100%;margin-bottom:24px;", ""], generateShimmerCss["default"]({
  start: 'calc(-1584px - 220px)',
  stop: 'calc(1584px - 220px)',
  size: '1584px'
}));
const Description = styled__default["default"].div.withConfig({
  componentId: "sc-vr9oku-2"
})(["height:24px;max-width:100px;width:100%;margin-bottom:24px;", ""], generateShimmerCss["default"]({
  start: 'calc(-1584px - 220px)',
  stop: 'calc(1584px - 220px)',
  size: '1584px'
}));
const Container = styled__default["default"].div.withConfig({
  componentId: "sc-vr9oku-3"
})(["box-sizing:border-box;padding:16px;border-width:1px;border-style:solid;border-radius:4px;border-color:#cccccc;width:100%;display:grid;grid-auto-flow:column;grid-template-columns:auto 2fr;column-gap:24px;"]);
const TextContainer = styled__default["default"].div.withConfig({
  componentId: "sc-vr9oku-4"
})(["display:flex;flex-direction:column;"]);
const ItemCardSkeleton = () => /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Photo, null), /*#__PURE__*/React__default["default"].createElement(TextContainer, null, /*#__PURE__*/React__default["default"].createElement(Title, null), /*#__PURE__*/React__default["default"].createElement(Description, null), /*#__PURE__*/React__default["default"].createElement(Description, null)));

exports.ItemCardSkeleton = ItemCardSkeleton;
